module.exports = __webpack_public_path__ + "static/media/12.fb0c3cdf.svg";